export const inlineBG = photo => ({
  background: `url(${photo})`
});
